import appData from '@/core/data';
import {mapUnitConfiguration} from '@/core/helpers/map-unit-configuration.helpers';
import {formatPrice} from '../../common/helpers/format-price';

export default {
	computed: {
		...mapUnitConfiguration(['unit', 'hoseOrientation', 'instrumentCount']),
		appData: () => appData,
	},
	methods: {
		getAppData(prop) {
			return appData[prop][this.unit.name];
		},
		isAppDataEmpty(prop) {
			return Object.keys(appData[prop][this.unit.name]).length === 0;
		},
		formatPrice(price, useNbsp) {
			return formatPrice(price, useNbsp);
		},
	},
};
